// src/lib/api.js
import axios from 'axios';

// URL base para el backend
// Usar rutas relativas para asegurar que siempre use el mismo dominio
export const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/api\/?$/, '');
export const API_BASE = BACKEND_URL + '/api';

export const http = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

// Alias para compatibilidad con componentes que importan { api }
export const api = http;

// Interceptor para añadir el token a todas las peticiones
http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de autenticación
http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Setea o limpia el token en headers (se usa desde AuthContext)
export function setAuthToken(token) {
  if (token) {
    localStorage.setItem('token', token);
    http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    localStorage.removeItem('token');
    delete http.defaults.headers.common['Authorization'];
  }
}

// Exportación por defecto del cliente HTTP
export default http;
